import styled from "@emotion/styled";

export const StyledInlinePromptContainer = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
  padding: 0 4px 0 20px;
  gap: 8px;
  border: 2px solid transparent;
  border-radius: 12px;
  background-image: linear-gradient(#fff, #fff),
    linear-gradient(90deg, #2b78ff 0%, #ce5cfb 50.06378293037415%, #8ed1f6 100%);
  background-origin: padding-box, border-box;
  background-clip: padding-box, border-box;
  box-sizing: border-box;
  width: 480px;
`;

export const StyledInlinePromptInput = styled.input`
  flex: 1;
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  border: none;
  outline: none;
  background: transparent;
  color: #000;

  &::placeholder {
    background: linear-gradient(
      90deg,
      #2b78ff 0%,
      #ce5cfb 50.06378293037415%,
      #f68eb4 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;
